module.exports = __webpack_public_path__ + "media/components/common/navMain/images/nav-back-5a9a16fd8822287854229d05ca5ff04b.gif";